import { Component, OnInit } from '@angular/core';
import { RepositoryService } from "../../shared/services/repository.service";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { HorizonCategory } from '../../_interfaces/HorizonCategory.model';
import { HorizonScanning } from '../../_interfaces/HorizonScanning.model';
import { RiskService } from '../../shared/services/risk.service';
import { HorizonScanningTerm } from '../../_interfaces/HorizonScanningTerm.model';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-horizon-scanning-add',
  templateUrl: './horizon-scanning-add.component.html',
  styleUrls: ['./horizon-scanning-add.component.css']
})
export class HorizonScanningAddComponent implements OnInit {

  horizonScan: HorizonScanning;
  addForm: FormGroup;
  horizonCategories: HorizonCategory[];
  submitted = false;
  update = false;
  function = "Add";


  horizonScanningTerms$: Observable<HorizonScanningTerm[]> = this.repository.getData('horizonscanning/terms').pipe(
    map((res) => res as HorizonScanningTerm[])
  );

  constructor(private formBuilder: FormBuilder,
    private repository: RepositoryService,
    private riskService: RiskService,
    private router: Router,
    private activeRoute: ActivatedRoute) { }

  ngOnInit() {

    const id: string = this.activeRoute.snapshot.params['id'];
    if (id != null) {
      this.update = true;
      this.function = "Update";
    }

    this.horizonScan = new HorizonScanning();

    this.addForm = this.formBuilder.group({
      HorizonCategoryId: ['', [Validators.required, Validators.min(0)]],
      Risk: ['', Validators.required],
      EffectOnSociety: ['', Validators.required],
      MitigatingActions: ['', Validators.required],
      OutlookDirection: ['', Validators.required],
      OutlookColour: ['', Validators.required],
      RiskType: [null, Validators.required],
      Term: [null]
    });

    this.getHorizonCategories();

    if (this.update) {
      this.getHorizonScanById();

    }
  }

  get riskTypes$() {
    return this.riskService.riskTypes$;
  }

  //TODO: need to cache these
  public getHorizonCategories() {
    let apiAddress: string = `horizonscanning/categories`;
    this.repository.getData(apiAddress)
      .subscribe(res => {
        this.horizonCategories = res as HorizonCategory[];
      });
  }

  public getHorizonScanById() {
    let id: string = this.activeRoute.snapshot.params['id'];
    let apiUrl: string = `horizonscanning/${id}`;

    this.repository.getData(apiUrl)
      .subscribe(res => {
        this.horizonScan = res as HorizonScanning;
        this.setFormFromHorizonScan();
      });
  }

  public setFormFromHorizonScan() {  
    this.f.Risk.setValue(this.horizonScan.risk);
    this.f.EffectOnSociety.setValue(this.horizonScan.effectOnSociety);
    this.f.MitigatingActions.setValue(this.horizonScan.mitigatingActions);
    this.f.OutlookDirection.setValue(this.horizonScan.outlookDirection);
    this.f.OutlookColour.setValue(this.horizonScan.outlookColour);
    this.f.HorizonCategoryId.setValue(this.horizonScan.horizonCategoryId);
    this.f.RiskType.setValue(this.horizonScan.riskTypeId);
    this.f.Term.setValue(this.horizonScan.term);
  }

  get f() { return this.addForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.updateFromForm();

    if (this.update) {
      this.UpdateHorizonScanningDetails();
    }
    else {
      this.postForm();
    }

  }

  onCancelForm() {
    this.router.navigate([`/horizon`]);
  }

  updateFromForm() {
    this.horizonScan.horizonCategoryId = this.f.HorizonCategoryId.value;
    this.horizonScan.risk = this.f.Risk.value;
    this.horizonScan.effectOnSociety = this.f.EffectOnSociety.value;
    this.horizonScan.mitigatingActions = this.f.MitigatingActions.value;
    this.horizonScan.outlookDirection = this.f.OutlookDirection.value;
    this.horizonScan.outlookColour = this.f.OutlookColour.value;
    this.horizonScan.riskTypeId = +this.f.RiskType.value;
    this.horizonScan.term = +this.f.Term.value;
  }

  postForm() {
    let apiAddress: string = `HorizonScanning`;

    this.repository.create(apiAddress, this.horizonScan)
      .subscribe(res => {
        this.router.navigate([`/horizon`]);
      }, error => {
        alert('Error:!' + error.message + '\n\n');
        this.router.navigate([`/horizon`]);
      },
        () => this.router.navigate([`/horizon`])
      );
  }

  UpdateHorizonScanningDetails() {
    let apiAddress: string = `HorizonScanning`;

    this.repository.update(apiAddress, this.horizonScan)
      .subscribe(res => {
        this.router.navigate([`/horizon`]);
      }, error => {
        //console.error("Error: ", error);
        alert('Error:!' + error.message + '\n\n');
          this.router.navigate([`/horizon`]);
      },
        () => this.router.navigate([`/horizon`])
      );

  }

}
